// extracted by mini-css-extract-plugin
module.exports = {"DropdownMenu":"DropdownMenu_DropdownMenu__FufSJ","DropdownMenuLink":"DropdownMenu_DropdownMenuLink__MIA1R"};